// extracted by mini-css-extract-plugin
module.exports = {"icon":"DropDownIcon_icon__IEfhArr9h1okCJl9HJLU3"};